import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Grid,
  Button,
  Divider,
  Stack,
} from "@mui/material";
import { vendorApi } from "../../api/api";

const EditProject = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;

  const [loading, setLoading] = useState(false);
  const [iconPreview, setIconPreview] = useState("");
  const [iconFile, setIconFile] = useState(null);

  const [form, setForm] = useState({
    project_name: "",
    address: "",
    city: "",
    number_of_plots: "",
    Description: "",
  });

  // Load existing data
  useEffect(() => {
    if (!state) return;

    setForm({
      project_name: state.ProjectName || "",
      address: state.Address || "",
      city: state.City || "",
      number_of_plots: state.NoOfPlots || "",
      Description: state.Description || "",
      totalArea:state.totalArea || ""
    });

    setIconPreview(state.IconUrl || "");
  }, [state]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleIconChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setIconFile(file);
      setIconPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async () => {
    if (!form.project_name || !form.city) {
      alert("Project name and City are required");
      return;
    }

    const formData = new FormData();
    formData.append("project_name", form.project_name);
    formData.append("address", form.address);
    formData.append("city", form.city);
    formData.append("number_of_plots", form.number_of_plots);
    formData.append("Description", form.Description);
    formData.append("totalArea",form.totalArea);

    if (iconFile) {
      formData.append("icon", iconFile);
    }

    setLoading(true);
    try {
      await vendorApi.editProject(state.id, formData);
      alert("Project updated successfully");
      navigate(-1);
    } catch (error) {
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 1100, mx: "auto", mt: 3 }}>
      <Card sx={{ borderRadius: 3 }}>
        <CardContent>
          <Typography variant="h5" fontWeight="bold">
            Edit Project
          </Typography>

          <Divider sx={{ my: 3 }} />

          
          {/* ICON */}
<Box mb={3} display="flex" flexDirection="column" alignItems="flex-start">
  <Typography mb={1}>Display Picture</Typography>

  {iconPreview && (
    <img
      src={iconPreview}
      alt="Project Icon"
      style={{
        width: 120,
        height: 120,
        borderRadius: 10,
        objectFit: "cover",
        border: "1px solid #ccc",
        marginBottom: 10,
      }}
    />
  )}

  <Button
    variant="outlined"
    component="label"
    size="small"          // <-- smaller button
    sx={{ textTransform: 'none', padding: '4px 10px', fontSize: '0.8rem' }}
  >
    Update Display Picture
    <input
      type="file"
      hidden
      accept="image/*"
      onChange={handleIconChange}
    />
  </Button>
</Box>

          <Divider sx={{ my: 3 }} />

          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Project Name"
                name="project_name"
                value={form.project_name}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="City"
                name="city"
                value={form.city}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Address"
                name="address"
                value={form.address}
                onChange={handleChange}
                multiline
                rows={3}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                type="number"
                label="Total Number of Plots"
                name="number_of_plots"
                value={form.number_of_plots}
                onChange={handleChange}
              />
            </Grid>
             <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                type="text"
                label="Total Area"
                name="totalArea"
                value={form.totalArea}
                onChange={handleChange}
              />
            </Grid>

            {/* DESCRIPTION */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Project Description"
                name="Description"
                value={form.Description}
                onChange={handleChange}
                multiline
                rows={6}
                placeholder="Enter project description..."
              />
            </Grid>
          </Grid>

          <Divider sx={{ my: 3 }} />

          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button variant="outlined" onClick={() => navigate(-1)}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Saving..." : "Update Project"}
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default EditProject;
